const ScheduleCollaboratorObject = {
    tempworkShiftDetail: undefined,
    workShiftDetailId: "",
    collaboratorsApply: [],
    scheduled: true,
    startsOn: ''
};

export default ScheduleCollaboratorObject;
